<div class="d-flex align-items-center" mat-dialog-title>
    <div class="spacer title">{{ data.type }}</div>
</div>

<div mat-dialog-content>
    <div class="all-questions" [formGroup]="checklistForm">
        <div formArrayName="answers">
            @for (question of questions; track question; let i = $index) {
                <div class="question" [formGroupName]="i">
                    @if (!question.icon) {
                        <div>
                            <div>{{ question.order }}. {{ question.question }}</div>
                            <div class="ms-3 mt-2">
                                <mat-radio-group formControlName="answer">
                                    <mat-radio-button class="me-2" value="JA">Ja</mat-radio-button>
                                    <mat-radio-button class="me-2" value="NEE">nee</mat-radio-button>
                                    <mat-radio-button value="NVT">N.v.t.</mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>
                    }
                    @if (question.icon) {
                        <div class="icon-check">
                            <img
                                (click)="
                                    checklistForm
                                        .get('answers')
                                        .get(i + '')
                                        .get('answer')
                                        .setValue(!item.checked)
                                "
                                src="/assets/images/vkm-icons/{{ question.icon }}" />
                            <div class="check">
                                <mat-checkbox #item formControlName="answer" value="JA">
                                    {{ question.question }}
                                </mat-checkbox>
                            </div>
                        </div>
                    }
                </div>
            }
        </div>

        <mat-form-field class="form-field w-100" appearance="fill">
            <mat-label>Opmerking</mat-label>
            <textarea
                matInput
                formControlName="comment"
                placeholder="Opmerking als bovenstaande niet akkoord is (stagnaties, aanwijzingen bevoegd gezag, afwijkingen, incidenten):"></textarea>
        </mat-form-field>

        @if (lastUpdated) {
            <div class="text-muted">Laatst aangepast</div>
            <div>{{ lastUpdated | date: 'dd-MM-yyyy HH:mm' }}</div>
        }
    </div>
</div>

<div class="actions d-flex justify-content-between" mat-dialog-actions>
    <button class="planning-button cancel" mat-raised-button mat-dialog-close="">Sluiten</button>
    <button class="planning-button confirm" (click)="onSubmit()" mat-raised-button color="primary">Opslaan</button>
</div>
